// Geometria condivisa dell'HUD.
// La leaderboard vive in UIScene, le scritte dei powerup in MainScene: le due scene
// disegnano sullo stesso angolo in alto a sinistra, quindi i numeri stanno qui una
// volta sola per evitare che si sovrappongano.

export const HUD_MARGIN = 20;

export const LB_WIDTH = 200;
export const LB_ROWS = 10;
export const LB_ROW_H = 15;
export const LB_HEADER_H = 32;
export const LB_PAD = 10;
export const LB_HEIGHT = LB_HEADER_H + LB_ROWS * LB_ROW_H + LB_PAD;

// Da chiusa resta solo la barra del titolo, che fa da maniglia per riaprirla.
export const LB_COLLAPSED_HEIGHT = LB_HEADER_H - 6;

export const LB_STORAGE_KEY = 'vexel_leaderboard_collapsed';

// Un telefono in orizzontale ha si' e no 400px di altezza: con le misure da
// desktop la leaderboard si mangerebbe meta' schermo e la kill feed finirebbe
// sotto il pollice sinistro. Sotto queste soglie passiamo al layout compatto.
export function isCompactViewport(width, height) {
  return width < 820 || height < 520;
}

// Tutte le misure dell'HUD in funzione della dimensione del gioco.
// Restituisce anche le altezze derivate, cosi' nessuno le ricalcola a mano.
export function hudMetrics(width, height) {
  const compact = isCompactViewport(width, height);

  const m = compact
    ? {
        compact: true,
        margin: 10,
        lbWidth: 148,
        lbRows: 5,
        lbRowH: 13,
        lbHeaderH: 24,
        lbPad: 8,
        lbTitleSize: 10,
        lbRowSize: 9,
        minimapSize: 92,
        bagFontSize: 13,
        timerFontSize: 17,
        kfMax: 3,
        kfHeight: 20,
        kfStep: 24,
        kfPad: 8,
        kfFontSize: 10,
        cashoutW: 150,
        cashoutH: 42,
        cashoutFontSize: 15,
      }
    : {
        compact: false,
        margin: HUD_MARGIN,
        lbWidth: LB_WIDTH,
        lbRows: LB_ROWS,
        lbRowH: LB_ROW_H,
        lbHeaderH: LB_HEADER_H,
        lbPad: LB_PAD,
        lbTitleSize: 14,
        lbRowSize: 11,
        minimapSize: 150,
        bagFontSize: 18,
        timerFontSize: 22,
        kfMax: 4,
        kfHeight: 24,
        kfStep: 29,
        kfPad: 10,
        kfFontSize: 12,
        cashoutW: 200,
        cashoutH: 50,
        cashoutFontSize: 20,
      };

  m.lbHeight = m.lbHeaderH + m.lbRows * m.lbRowH + m.lbPad;
  m.lbCollapsedHeight = m.lbHeaderH - 6;
  return m;
}

// Righe create in scena: il layout compatto ne mostra meno, ma gli oggetti Phaser
// esistono comunque, cosi' un resize non deve ricrearli.
export const LB_MAX_ROWS = LB_ROWS;

// La preferenza sopravvive al refresh: chi non vuole la classifica non deve
// richiuderla a ogni partita.
export function loadLeaderboardCollapsed() {
  try {
    return localStorage.getItem(LB_STORAGE_KEY) === '1';
  } catch (e) {
    return false;
  }
}

export function saveLeaderboardCollapsed(collapsed) {
  try {
    localStorage.setItem(LB_STORAGE_KEY, collapsed ? '1' : '0');
  } catch (e) {}
}

// Prima coordinata y libera sotto il pannello, aperto o chiuso che sia.
export function hudBelowLeaderboard(collapsed, metrics) {
  const m = metrics || hudMetrics(1280, 720);
  return m.margin + (collapsed ? m.lbCollapsedHeight : m.lbHeight) + 14;
}

// Evento globale: UIScene apre/chiude, MainScene rialza o riabbassa i powerup.
export const LB_TOGGLE_EVENT = 'vexel_leaderboard_toggled';
